import React, { useEffect, useState } from "react";
import "./CouponModal.css";
import { IoClose } from "react-icons/io5";

const coupons = [
    { code: "PWYES", discount: 400, bank: "Yes bank" },
    { code: "PWICICI", discount: 400, bank: "ICICI bank" },
    { code: "PWHDFC", discount: 400, bank: "HDFC bank" },
    { code: "PWAB", discount: 400, bank: "AB bank" },
];

const CouponModal = ({ show, onClose, setCouponCode }) => {
    const [selectedCoupon, setSelectedCoupon] = useState("");
    const [manualInput, setManualInput] = useState("");



    useEffect(() => {
        if (selectedCoupon) {
            setCouponCode(selectedCoupon);
        }
    }, [selectedCoupon, setCouponCode]);

    const handleApplyCoupon = (code) => {
        setSelectedCoupon(code);
        setManualInput(code);
        onClose(); // Close after selection
    };

    const handleManualApply = () => {
        if (manualInput.trim() !== "") {
            setSelectedCoupon(manualInput.trim());
            onClose(); // Close after manual entry
        }
    };

    if (!show) return null;

    return (
        <div className="coupon-modal-overlay">
            <div className="coupon-modal-container">
                <div className="coupon-modal-header">
                    <h3>Apply Coupons</h3>
                    <button onClick={onClose} className="coupon-close-btn">
                        <IoClose color="red" size={30} />
                    </button>
                </div>

                <div className="coupon-modal-input">
                    <input
                        type="text"
                        placeholder="Enter coupon code ?"
                        value={manualInput}
                        onChange={(e) => setManualInput(e.target.value)}
                    />
                    <button className="coupon-apply-btn-input" onClick={handleManualApply}>
                        Apply
                    </button>
                </div>

                <div className="coupon-coupon-list">

                    {coupons.length === 0 ? (
                        <div className="no-coupon-coupon-card">
                            <p>No other coupons available</p>
                        </div>
                    ): coupons.map((c, idx) => (
                            <div className="coupon-coupon-card" key={idx}>
                                <div className="coupon-coupon-details">
                                    <h4>
                                        {c.code} - ₹{c.discount}
                                    </h4>
                                    <p>Payment through {c.bank} credit card to avail the offer.</p>
                                    <a href="#">coupon details</a>
                                </div>
                                <button
                                    className="coupon-apply-btn"
                                    onClick={() => handleApplyCoupon(c.code)}
                                >
                                    Apply
                                </button>
                            </div>
                        ))}
                </div>

                {selectedCoupon && (
                    <div className="coupon-selected-message">
                        <strong>Selected Coupon:</strong> {selectedCoupon}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CouponModal;
